<template>
  <div>

    <b-card
      class="business-card"
    >

      <section id="faq-tabs">
        <b-tabs
          vertical
          content-class="col-12 col-md-8 col-lg-9"
          pills
          nav-wrapper-class="faq-navigation col-md-4 col-lg-3 col-12"
          nav-class="nav-left"
        >

          <!-- configuration tab -->
          <b-tab
            v-for="(item, index) in institutions"
            :key="item.name"
            :active="!index"
          >

            <!-- title -->
            <template #title>
              <feather-icon
                :icon="item.icon"
                size="18"
                class="mr-1"
              />
              <span class="font-weight-bold">{{ item.name }}</span>
            </template>

            <!-- <item.component /> -->
            <component :is="item.component" />
          </b-tab>
        <!--/ payment tab -->

        </b-tabs>
      </section>
    </b-card>
    <!--/ configuration tabs pills -->

  </div>
</template>

<script>
import {
  BCard, BTabs, BTab,
} from 'bootstrap-vue'
import InstitutionLimit from './InstitutionLimit.vue'
import RegulatoryLimitReport from './RegulatoryLimitReport.vue'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    InstitutionLimit,
    RegulatoryLimitReport,
  },
  data() {
    return {
      institutions: [
        {
          name: this.$t('Institution Limit'),
          icon: 'PowerIcon',
          component: InstitutionLimit,
        },
        {
          name: this.$t('Regulatory Limit'),
          icon: 'InfoIcon',
          component: RegulatoryLimitReport,
        },
      ],
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-faq.scss';
</style>
